import { useEffect } from "react";
import { useAuthStore } from "../contexts/AuthContext";
import { useAccountSettingDispatch } from "../contexts/AccountSettingsContext";

export default function useGetAccountSettings() {
  const accountSettingDispatch = useAccountSettingDispatch();
  const {selectedAccount} = useAuthStore();

  useEffect(() => {
    accountSettingDispatch({ type: "setIsLoadingAccountSettings", payload: true });

  
    let accountId = selectedAccount.id? selectedAccount.id: 0 
    let url = `/api/accounts/${accountId}/account-settings`;

    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        accountSettingDispatch({ type: "setAccountSettings", payload: data });
        accountSettingDispatch({ type: "setIsLoadingAccountSettings", payload: false });
      });
  }, [selectedAccount, accountSettingDispatch]);
}
